/* eslint-disable jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BN from 'bignumber.js';
import cn from 'classnames';
import theme from '../../../../../theme';
import { formatToken, formatDollars } from '../../../../../helpers/token-helper';
import {
  TOKEN_OPTIONS,
  OM,
  OM_STAKING_MIGRATE_STATUS,
} from '../../../../../constants/blockchain-constants';
import s from '../item.module.scss';
import { useGetTheme } from '../../../../../hooks/useGetTheme';
import {
  ColumnTotalStakedAmountTitle,
  ColumnStatusTitle,
  ColumnEstimatedAprTitle,
  ColumnEstimatedDailyRewardsTitle,
  ColumnEarnedRewardsTitle,
} from '../../../../../components/Stake/column';

const OmV1Item = ({ unstakedBalance, migrateStatus, isActive, usdPrice, onClick }) => {
  const colors = useGetTheme();

  const getWrapBgColor = () => ({ style: { backgroundColor: colors.listAssetBackground } });
  const getTitleColor = () => ({ style: { color: colors.text } });

  const unstakedBalanceInUSD = new BN(unstakedBalance).times(usdPrice).toFixed(0, BN.ROUND_DOWN);

  return (
    <div className={cn(s.wrap, { [s.active]: isActive })} {...getWrapBgColor()} onClick={onClick}>
      <ColumnTotalStakedAmountTitle isMobile />
      <div className={s.col}>
        <div className={s.logoContainer}>
          <img className={s.logo} src={TOKEN_OPTIONS[OM].icon} alt='' />
        </div>
        <div className={s.stakeBalance}>
          <p className={s.topLine} {...getTitleColor()}>
            {'OLD OM'} {formatToken(unstakedBalance)}{' '}
          </p>
          {usdPrice ? <p className={s.bottomLine}>${formatDollars(unstakedBalanceInUSD)}</p> : null}
        </div>
        <div />
      </div>
      <ColumnStatusTitle isMobile />
      <div className={cn(s.col, s.colColumn)}>
        <span className={s.topLine} style={{ color: theme.palette.mantra.pink, fontSize: '18px' }}>
          {migrateStatus === OM_STAKING_MIGRATE_STATUS.NEED_RUN_MIGRATE ? '—' : 'Migrating'}
        </span>
      </div>
      <ColumnEstimatedAprTitle isMobile />
      <div className={s.col}>
        <div>
          <div className={s.topLine} style={{ color: theme.palette.mantra.pink }}>
            —
          </div>
        </div>
      </div>
      <ColumnEstimatedDailyRewardsTitle isMobile />
      <div className={s.col}>
        <span
          className={s.topLine}
          style={{ color: theme.palette.mantra.pink, display: 'inline-block' }}
        >
          —
        </span>
      </div>
      <ColumnEarnedRewardsTitle isMobile />
      <div className={s.col} style={{ flexWrap: 'nowrap' }}>
        <div>
          <span className={s.topLine} style={{ color: theme.palette.mantra.pink }}>
            —
          </span>
        </div>
      </div>
    </div>
  );
};

OmV1Item.propTypes = {
  usdPrice: PropTypes.number,
  unstakedBalance: PropTypes.string.isRequired,
  migrateStatus: PropTypes.string.isRequired,
  rewardEarned: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  rewardBalance: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  stakeTime: PropTypes.string,
};

OmV1Item.defaultProps = {
  usdPrice: 0,
  stakeTime: null,
};

export default connect((state) => ({
  usdPrice: state.basic.currency.USD[OM],
  unstakedBalance: state.OMstake.stake.unstakedBalance,
  migrateStatus: state.OMstake.stake.migrateStatus,
  stakeTime: state.OMstake.stake.stakeTime,
  rewardEarned: state.OMstake.stake.rewardEarned,
  rewardBalance: state.OMstake.stake.rewardBalance,
}))(OmV1Item);
